import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

import User from '../../../bower_components/teknisavuecomponents/assets/interfaces/User';
import Periodo from '../../../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import HttpRequest from '../../../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '../../../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DialogUtils from '../../../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import Util from '../../../bower_components/teknisavuecomponents/assets/utils/Util';
import { OcorrenciaController, OcorrenciaAprovacao } from "@/assets/ts/controller/OcorrenciaController";
import AprovacaoOcorrenciaPopup from '@/components/AprovacaoOcorrenciaPopup/AprovacaoOcorrenciaPopup.vue';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';

import DefaultScreenContent from '@/components/DefaultScreenContent.vue';
import CrudGrid from '../../../bower_components/teknisavuecomponents/components/grids/CrudGrid.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import ConfirmationDialog from '../../../bower_components/teknisavuecomponents/components/popups/ConfirmationDialog.vue';
import NovaOcorrenciaPopup from '@/components/ocorrencia/NovaOcorrenciaPopup/NovaOcorrenciaPopup.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import DadosVinculoPopup from '@/components/DadosVinculoPopup/DadosVinculoPopup.vue';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'AprovacaoOcorrencia',
  components: {
    DefaultScreenContent,
    CrudGrid,
    ConfirmationDialog,
    TkVisualizer,
    NovaOcorrenciaPopup,
    AprovacaoOcorrenciaPopup,
    DadosVinculoPopup
  },
})

class AprovacaoOcorrencia extends Vue {
  // #region [ STORE ]
  @Getter('user')
  private user: User;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Mutation('changeCurrentView')
  private changeCurrentView: (viewTitlw: string) => void;
  // #endregion

  // #region [ DATA ]
  private showAprovaOcorrenciaPopup = false;

  private showDadosVinculo = false;

  private numeroVinculo?: number = 0;

  private readonly APROVAROCORRENCIAOPERATION = 'APROVAR';

  private readonly REPROVAROCORRENCIAOPERATION = 'REJEITAR';

  private loading = false;

  private ocorrenciaAprovacao: OcorrenciaAprovacao = {
    NRPROGOCORRENCIA: null,
    NRVINCULOM: null,
    NMVINCULOM: null,
    NRTIPOPROGOCORRENCIA: null,
    NRMOTIVOOCORFREQ: null,
    DTINICIOPROGOCOR: null,
    IDDIASSEMANA: null
  };

  private view = {
    title: 'Ocorrências',
    popUpTitle: 'Ocorrência',
  };

  private get filtersDoenca() {
    if (!this.user) {
      return null;
    }

    const filters = {
      NRORG: this.user.nrorg
    };

    return filters;
  }

  private fieldItems = {
    NMDIAGNOST: [],
  };

  private operations = {
    APROVAR: {
      route: 'aprovarOcorrencia',
      confirmation: {
        title: 'Aprovar Ocorrência',
        message: 'Deseja realmente aprovar a ocorrência?',
      },
      messages: {
        success: 'Ocorrência aprovada com sucesso.',
      },
    },
    REJEITAR: {
      route: 'rejeitarOcorrencia',
      confirmation: {
        title: 'Rejeitar Ocorrência',
        message: 'Deseja realmente rejeitar a ocorrência?',
      },
      messages: {
        success: 'Ocorrência rejeitada com sucesso.',
      },
    },
  };

  private operationsMessages = {
    invalid: 'Operação inválida.',
    operationNotAvailable: 'Opção não disponível',
  };

  private grid = {
    name: this.view.popUpTitle,
    messages: {
      loadingText: 'Carregando Ocorrências...',
      noDataText: 'Nenhuma Ocorrência Encontrada.'
    },
    triggers: {
      reload: 0,
    },
    dataSource: {
      route: 'getOcorrenciasPendentesPeriodoVinculosGestor',
      filters: {
        NRORG: this.$store.state.user.nrorg,
        NRESTRUTURAM: this.$store.state.estruturaGerencialAtual ? this.$store.state.estruturaGerencialAtual.NRESTRUTURAM : null,
        NRPERIODOAPURACAO: this.$store.state.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
        CDOPERADOR: this.$store.getters.user.cdoperador,
      }
    },
    toolbarActions: [
      'reload',
      {
        name: 'addOcor',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.openNovaOcorrenciaPopup),
      }
    ],
    actions: [
      'view',
      {
        name: 'Aprovar',
        value: 'aprovar',
        icon: 'mdi-check',
        action: ControleAcessoWrapper.atualizar(this.aprovarOcorrencia),
        mode: 'view',
        condition: this.operadorAprovaOcorrencias,
      },
      {
        name: 'Rejeitar',
        value: 'rejeitar',
        icon: 'mdi-close',
        action: ControleAcessoWrapper.atualizar(this.rejeitarOcorrencia),
        mode: 'view',
        condition: this.operadorAprovaOcorrencias,
      },
      // {
      //   name: 'Download',
      //   value: 'download',
      //   icon: 'mdi-download',
      //   action: this.downloadFile,
      //   mode: 'view',
      //   condition: this.hasFile,
      // },
      {
        name: 'Ver Arquivo',
        value: 'viewFile',
        icon: 'mdi-file-eye',
        action: this.viewFile,
        mode: 'view',
        condition: this.ocorrenciaHasFile,
      },
      {
        name: 'Dados do Vínculo',
        value: 'dadosVinculo',
        icon: 'mdi-account',
        action: this.viewDadosVinculo,
        mode: 'view',
      },
    ],
  };

  private get gridColumns() {
    return [
      {
        text: 'Vínculo',
        value: 'NMVINCULOM',
        name: 'NMVINCULOM',
        cols: 12,
        tag: 'v-text-field',
        required: true,
        showOnList: true,
      },
      {
        text: 'Início Ocorrência',
        value: 'DTINICIOPROGOCOR',
        name: 'DTINICIOPROGOCOR',
        cols: 3,
        type: 'date',
        tag: 'TkDate',
        required: true,
        showOnList: true,
      },
      {
        text: 'Dias Ocorrência',
        value: 'DIAOCORRE',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Fim Ocorrência',
        value: 'DTFIMPROGOCOR',
        type: 'date',
        cols: 3,
        tag: 'TkDate',
        required: false,
        showOnForm: true,
      },
      {
        text: 'Situação',
        value: 'DSCONFIRM',
        valueField: 'IDPROGOCORCONFIRMADA',
        descriptionField: "DSCONFIRM",
        readonly: true,
        defaultValue: {IDPROGOCORCONFIRMADA: 'P', DSCONFIRM: 'Pendente' },
        type: 'text',
        cols: 3,
        tag: 'TkSelect',
        hint: 'Situacao da ocorrencia',
        items: [
          {IDPROGOCORCONFIRMADA: 'S', DSCONFIRM: 'Confirmada' },
          {IDPROGOCORCONFIRMADA: 'N', DSCONFIRM: 'Rejeitada' },
          {IDPROGOCORCONFIRMADA: 'P', DSCONFIRM: 'Pendente' }
        ]
      },
      {
        text: 'Tipo do Dia',
        cols: 6,
        value: 'IDTIPODIACALENDARIO',
        type: 'text',
        tag: 'TkSelect',
        showOnList: false,
        valueField: 'IDTIPODIACALENDARIO',
        descriptionField: 'DSTIPODIACALENDARIO',
        items: [
          {
            DSTIPODIACALENDARIO: 'Feriado',
            IDTIPODIACALENDARIO: 'FERIADO',
          },
          {
            DSTIPODIACALENDARIO: 'Ponto Facultativo',
            IDTIPODIACALENDARIO: 'PONTOFACULTATIVO',
          },
        ],
      },
      {
        text: 'Tipo do Horário',
        cols: 6,
        value: 'IDTIPOHORARIO',
        type: 'text',
        tag: 'TkSelect',
        showOnList: false,
        valueField: 'IDTIPOHORARIO',
        descriptionField: 'NMTIPOHORARIO',
        items: [
          {
            NMTIPOHORARIO: 'Folga',
            IDTIPOHORARIO: 'F',
          },
          {
            NMTIPOHORARIO: 'Compensado',
            IDTIPOHORARIO: 'C',
          },
          {
            NMTIPOHORARIO: 'Normal',
            IDTIPOHORARIO: 'N',
          },
          {
            NMTIPOHORARIO: 'Turno',
            IDTIPOHORARIO: 'T',
          },
        ],
      },
      {
        text: 'Tipo de Ocorrência',
        cols: 4,
        tag: 'v-text-field',
        value: 'NMTIPOPROGOCORRENCIA',
        valueField: "NRTIPOPROGOCORRENCIA",
        descriptionField: "NMTIPOPROGOCORRENCIA",
        route: "getTpOcorrencia",
        required: true
      },
      {
        text: 'Motivo de Ocorrência',
        value: 'DSMOTIVOOCORFREQ',
        valueField: "NRMOTIVOOCORFREQ",
        descriptionField: "DSMOTIVOOCORFREQ",
        cols: 4,
        tag: 'v-text-field',
      },
      {
        text: 'Horário Inicial',
        value: 'HRINICIO',
        cols: 2,
        tag: 'v-text-field',
      },
      {
        text: 'Horário Final',
        value: 'HRFIM',
        cols: 2,
        tag: 'v-text-field',
      },
      {
        text: 'Horário',
        cols: 6,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'NRHORDIAM',
        valueField: 'NRHORDIAM',
        descriptionField: 'NMHORDIAH',
        route: 'getHoradiah',
        filters: this.filtersDoenca,
        reloadOnCreation: true,
        showOnList: false,
      },
      {
        text: 'Mínimo Horas',
        cols: 3,
        value: 'QTMINIMAPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
      },
      {
        text: 'Máximo Horas',
        cols: 3,
        value: 'QTMAXIMAPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
      },
      {
        text: 'Doença',
        cols: 12,
        tag: 'TkSelect',
        autocomplete: true,
        value: 'CDDIAGNOST',
        valueField: 'CDDIAGNOST',
        descriptionField: 'NMDIAGNOST_VIEW',
        items: this.fieldItems.NMDIAGNOST,
        showOnList: false,
        change: this.doencaOnChange,
      },
      {
        text: 'Médico/Dentista',
        cols: 12,
        tag: 'TkSelect',
        value: 'NRPESSOA',
        valueField: 'NRPESSOA',
        descriptionField: 'NMPESSOA_VIEW',
        route: 'getPessoaConselhoReg',
        reloadOnCreation: true,
        filters: this.filtersDoenca,
        showOnList: false,
      },
      {
        text: 'Situação de Frequência do Gatilho',
        cols: 12,
        tag: 'TkSelect',
        value: 'NRSITUFREQGATILHO',
        valueField: "NRSITUFREQGATILHO",
        descriptionField: "DSSITUFREQUENCIA_VIEW",
        route: "getSituFrequencias",
        reloadOnCreation: true,
        filters: this.filtersDoenca,
        showOnList: false,
      },
      {
        text: 'Qtd. Mínima do Gatilho',
        cols: 4,
        value: 'QTMINGATILHOPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
      },
      {
        text: 'Qtd. Máxima do Gatilho',
        cols: 4,
        value: 'QTMAXGATILHOPROGOCOR',
        type: 'text',
        tag: 'v-text-field',
        mask: '##:##',
        showOnList: false,
      },
      {
        text: 'Vr. Coeficiente de Acres. (%)',
        value: 'VRCOEFICIENTEACRESCIMO',
        type: 'text',
        cols: 4,
        tag: 'v-text-field',
        showOnList: false,
      },
      {
        text: 'Observação',
        value: 'DSOBSERVACAO',
        type: 'text',
        cols: 12,
        tag: 'v-text-field'
      },
      {
        text: 'Incluído em',
        value: 'DTINCLUSAO',
        name: 'DTINCLUSAO',
        cols: 3,
        tag: 'TkDate',
        required: false,
        showOnList: false,
      },
      {
        text: 'Incluído por',
        value: 'NMOPERINCLUSAO',
        name: 'NMOPERINCLUSAO',
        cols: 6,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Org. Inclusão',
        value: 'NRORGINCLUSAO',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Atualizado em',
        value: 'DTULTATU',
        name: 'DTULTATU',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Atualizado por',
        value: 'NMOPERULTATU',
        name: 'NMOPERULTATU',
        cols: 6,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Org. Atualização',
        value: 'NRORGULTATU',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
      },
      {
        text: 'Documento',
        value: 'ANEXO',
        type: 'file',
        cols: 12,
        tag: 'v-file-input',
        readonlyField: true,
        showOnList: false
      }
    ];
  }

  private confirmationDialog = {
    isVisible: false,
    message: '',
    icon: '',
  };

  private visualizer = {
    show: false,
    base64: '',
    mimeType: '',
    fileName: '',
  };

  private novaOcorrencia = {
    show: false,
  };
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.view.title);
  }

  private mounted() {
    if (!this.operadorIsDP() && this.user.idaprovocorrencia !== 'S') {
      const message = 'Somente operadores com perfil de acesso administrador podem aprovar/reprovar ocorrências!';
      SnackbarUtils.showMessage(message, 'alert', 5000);
    }
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('periodoDemonstrativoAtual')
  private onChangePeriodo(newPeriodo: Periodo) {
    this.grid.dataSource.filters.NRPERIODOAPURACAO = newPeriodo.NRPERIODOAPURACAO;
    this.reloadGridData();
  }

  @Watch('estruturaGerencialAtual')
  private onChangeEstrutura(newEstrutura: any) {
    this.grid.dataSource.filters.NRESTRUTURAM = newEstrutura.NRESTRUTURAM;
    this.reloadGridData();
  }
  // #endregion

  // #region [ METHODS ]
  private reloadGridData() {
    return this.grid.triggers.reload++;
  }

  private async alteraStatusOcorrencia(row: any, processo: string) {
    if(this.$store.state.user.nrorg == 20 && 
        (!this.operadorIsDP() && this.$store.state.user.nrvinculom == row.NRVINCULOM)) {
      SnackbarUtils.showMessage(`Não é possível realizar ${processo} para o seu próprio vínculo`, 'error');
      return;
    }

    const operations = Object.keys(this.operations);
    const currentOperation: string = operations.find((op: string) => op === processo);
    const operation: any = this.operations[currentOperation];

    if (!operation) {
      throw this.operationsMessages.invalid;
    }

    if(operation.confirmation.title == 'Rejeitar Ocorrência') {
      this.reprovaOcorrencia(row);
    } else {
      await DialogUtils.show(operation.confirmation.title, operation.confirmation.message, async () => {
        this.requisitaAlteracaoStatusOcorrencia(row, operation);
      });
    }
  }

  private async requisitaAlteracaoStatusOcorrencia(row: any, operation: any) {
    try {
      const nrprogocorrencia = row.NRPROGOCORRENCIA;
      const response = await HttpRequest.post(operation.route, {
        requestType: 'Row',
        row: {
          NRPROGOCORRENCIA: nrprogocorrencia,
          NRORG: this.$store.getters.user.nrorg,
          CDOPERADOR: this.$store.getters.user.cdoperador,
        },
      });

      if (response.data.messages) {
        throw response.data.messages[0].message;
      }

      SnackbarUtils.showMessage(operation.messages.success);
    } catch (err) {
      const e = err as any;
      SnackbarUtils.showMessage(e, 'error');
    } finally {
      this.reloadGridData();
    }
  }

  private async aprovarOcorrencia(row: any) {
    const operation = this.APROVAROCORRENCIAOPERATION;

    await this.alteraStatusOcorrencia(row, operation);
  }

  private async rejeitarOcorrencia(row: any) {
    const operation = this.REPROVAROCORRENCIAOPERATION;

    await this.alteraStatusOcorrencia(row, operation);
  }

  private hasFile(
    row: any,
  ): boolean {
    const ocorrenciaHasFile = !Util.isEmptyOrBlank(row.DSPATH);

    return ocorrenciaHasFile;
  }

  private async downloadFile(
    row: any,
  ) {
    const nrMarcacao = row.NRPROGOCORRENCIA;
    const date = row.DTINICIOPROGOCOR;
    const nrVinculo = row.NRVINCULOM;

    this.loading = true;

    try {
      await OcorrenciaController.downloadOcorrenciaFile(
        nrVinculo, nrMarcacao, date,
      );
    } catch(err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  public operadorIsDP(): boolean {
    const isDP = this.user.dp;

    return isDP;
  }

  /**
   * Função responsável por informar se o operador está autorizado a aprovar ocorrencias
   * 
   * @returns boolean
   */
  private operadorAprovaOcorrencias(row: { ID_OPER_APROVA_OCOR: string }) {
    return this.operadorIsDP() || row.ID_OPER_APROVA_OCOR === 'S';
  }

  private ocorrenciaHasFile(row: any): boolean {
    return !!row.DSPATH;
  }

  private async viewFile(row: any) {
    const nrOcorrencia: string = row.NRPROGOCORRENCIA;
    const nrVinculo = row.NRVINCULOM;

    this.loading = true;

    try {
      const fileData = await OcorrenciaController.getOcorrenciaFile(nrOcorrencia);
      const { base64, type } = fileData;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      const fileName = `ocorrencia_${nrVinculo}_${nrOcorrencia}`;

      this.visualizer.show = true;
      this.visualizer.base64 = fullBase64;
      this.visualizer.mimeType = type;
      this.visualizer.fileName = fileName;
    } finally {
      this.loading = false;
    }
  }

  private openNovaOcorrenciaPopup() {
    this.novaOcorrencia.show = true;
  }

  private async crudGridAfterReload() {
    // Request doencas
    if (!this.fieldItems.NMDIAGNOST || (Array.isArray(this.fieldItems.NMDIAGNOST) && this.fieldItems.NMDIAGNOST.length === 0)) {
      try {
        const response = await HttpRequest.get('getDiagnost', {
          requestType: 'FilterData',
          NRORG: this.user.nrorg,
        }, false);
  
        if (typeof response.data === 'string') {
          throw new Error(response.data);
        }

        this.fieldItems.NMDIAGNOST = response.data.dataset.data;
      } catch (err) {
        const message = 'Não foi possível carregar as informações de doença.';
        SnackbarUtils.showMessage(message, 'error');
  
        throw err;
      }
    }
  }

  // Rotina necessaria pois eh necessario manipular os dados do campo NMDIAGNOST
  private doencaOnChange(row) {
    const CIDData = this.fieldItems.NMDIAGNOST;
    const rowCDDIAGNOST = row.CDDIAGNOST;
    if (!rowCDDIAGNOST) {
      return;
    }
    
    const doencaData = CIDData.find((item) => item.CDDIAGNOST === rowCDDIAGNOST);
    if (!doencaData) {
      row.CDTABECDI = null;
      return;
    }
    
    row.CDTABECDI = doencaData.CDTABECDI;
  }

  private async reprovaOcorrencia(row: any) {
    const ocorrenciaAprovacao: OcorrenciaAprovacao = {
      ...row,
      IDAPROVACAO: 'R',
    };

    this.showAprovacaoOcorrenciaPopup(ocorrenciaAprovacao);
  }

  private showAprovacaoOcorrenciaPopup(ocorrencia: OcorrenciaAprovacao) {
    this.ocorrenciaAprovacao = { ...ocorrencia };
    this.showAprovaOcorrenciaPopup = true;
  }

  private aprovacaoOcorrenciaOnClose() {
    this.reloadGridData();
    return true;
  }


  private viewDadosVinculo(row: any) {
    try {
      this.numeroVinculo = parseInt(row.NRVINCULOM, 10);
      this.showDadosVinculo = true;
      this.loading = false;
    } catch (err) {
      let message = '';
      let err2 = err as any;

      if (err2.name === 'ExpectedError') {
        message = err2.message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar os Dados do Vínculo!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }
  }
  // #endregion
}

export default AprovacaoOcorrencia;